var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFridge = function SvgFridge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.689,
    height: 49.386
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e4dcd3",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.465 0H4.224A4.23 4.23 0 0 0 0 4.224v38.339a4.23 4.23 0 0 0 3.9 4.2v1.326a1.3 1.3 0 0 0 2.6 0v-1.3h24.691v1.3a1.3 1.3 0 0 0 2.6 0v-1.341a4.22 4.22 0 0 0 3.9-4.2V4.211A4.23 4.23 0 0 0 33.465 0m1.625 42.563a1.625 1.625 0 0 1-1.624 1.624H4.224A1.625 1.625 0 0 1 2.6 42.563V4.224A1.625 1.625 0 0 1 4.224 2.6h29.241a1.625 1.625 0 0 1 1.625 1.624Z",
    "data-name": "Path 67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.592 12.996a1.3 1.3 0 0 0-1.3 1.3v7.8a1.3 1.3 0 0 0 2.6 0v-7.8a1.3 1.3 0 0 0-1.3-1.3",
    "data-name": "Path 68"
  })))));
};
export default SvgFridge;